import Vue from 'vue'
import Router from 'vue-router'
import MapCondition from '../container/MapCondition'

Vue.use(Router)

export default new Router({
  routes: [
    {
      //图说路况
      path: '/',
      name: 'MapCondition',
      component: resolve => require(['../container/tsRoadCondition/Index.vue'], resolve),
      children: [],
      meta: {keepAlive: true}
    },
    {
      //图说路况--搜索
      path: '/SearchInfo',
      name: 'SearchInfo',
      component: resolve => require(['../container/tsRoadCondition/Search.vue'], resolve),
      meta: {keepAlive: true}
    },
    {
      //图说路况--突发事件
      path: '/Emergency',
      name: 'Emergency',
      component: resolve => require(['../container/tsRoadCondition/emergency/Index.vue'], resolve),
    },
    {
      // 旅游景点
      path: '/scenicSpot',
      name: 'ScenicSpot',
      component: resolve => require(['../container/scenicSpot/Index.vue'], resolve),
      children: []
    },
    {
      //旅游景点详情页
      path: '/scenicSpotInfo',
      name: 'ScenicSpotInfo',
      component: resolve => require(['../container/scenicSpot/Info.vue'], resolve),
    },
    {
      //旅游景点详情页
      path: '/scenicSpotSearch',
      name: 'ScenicSpotSearch',
      component: resolve => require(['../container/scenicSpot/Search.vue'], resolve),
    },
    {
      // 科技示范路（南绕城）
      path: '/drst',
      name: 'Drst',
      component: resolve => require(['../container/drst/Index.vue'], resolve),
      children: [],
      meta: {keepAlive: true}
    },
    {
      // 科技示范路（南绕城）
      path: '/drstIntroduce',
      name: 'DrstIntroduce',
      component: resolve => require(['../container/drst/Introduce.vue'], resolve),
    },
    {
      // 科技示范路（南绕城）
      path: '/drstJTIndex',
      name: 'DrstJTIndex',
      component: resolve => require(['../container/drst/JTIndex.vue'], resolve),
    },
    {
      // 科技示范路--路况通知
      path: '/drst/notice',
      name: 'Notice',
      component: resolve => require(['../container/tsRoadCondition/roadNotice/Index.vue'], resolve),
    },
    {
      // 科技示范路--服务区详情
      path: '/drst/serviceArea',
      name: 'ServiceArea',
      component: resolve => require(['../container/tsRoadCondition/serviceArea/Index.vue'], resolve),
    },
    {
      // 科技示范路--服务区详情(query传参)
      path: '/drst/serviceAreaDetail',
      name: 'ServiceAreaDetail',
      component: resolve => require(['../container/tsRoadCondition/serviceArea/serviceAreaDetail.vue'], resolve),
    },
    {
      // 科技示范路--收费站详情
      path: '/drst/tollStation',
      name: 'TollStation',
      component: resolve => require(['../container/tsRoadCondition/tollStation/Index.vue'], resolve),
    },
    {
      // 科技示范路--交通管制详情
      path: '/drst/trafficControl',
      name: 'TrafficControl',
      component: resolve => require(['../container/tsRoadCondition/trafficControl/Index.vue'], resolve),
    },
    {
      // 科技示范路--计划施工详情
      path: '/drst/planConstruction',
      name: 'PlanConstruction',
      component: resolve => require(['../container/tsRoadCondition/planConstruction/Index.vue'], resolve),
    },
    {
      // 科技示范路--天气预警列表
      path: '/drst/roadNotice/weatherWarning',
      name: 'WeatherWarning',
      component: resolve => require(['../container/tsRoadCondition/roadNotice/weatherWarning.vue'], resolve),
    },
    {
      // 科技示范路--天气预警详情
      path: '/drst/roadNotice/warningDetail',
      name: 'WeatherWarningDetail',
      component: resolve => require(['../container/tsRoadCondition/roadNotice/warningDetail.vue'], resolve),
    },
    {
      // 科技示范路--易出车祸路段列表
      path: '/drst/accidentSection',
      name: 'AccidentSection',
      component: resolve => require(['../container/tsRoadCondition/accidentSection/Index.vue'], resolve),
    },
    {
      // 路况
      path: '/roadCondition',
      name: 'RoadCondition',
      component: resolve => require(['../container/roadCondition/Index.vue'], resolve),
      children: [],
      meta: {keepAlive: true}
    },
    {
      // 路况
      path: '/wechatRoadCondition',
      name: 'WechatRoadCondition',
      component: resolve => require(['../container/roadCondition/WechatIndex.vue'], resolve),
      children: [],
      meta: {keepAlive: true}
    },
    {
      // 路况概览
      path: '/roadOverView',
      name: 'RoadOverView',
      component: resolve => require(['../container/roadCondition/roadOverView.vue'], resolve),
      meta: {keepAlive: true}
    },
    {
      // 路况概览详情
      path: '/roadOverViewDetail',
      name: 'RoadOverViewDetail',
      component: resolve => require(['../container/roadCondition/roadOverViewDetail.vue'], resolve),
      // meta: {keepAlive: true}
    },
    {
      // 路况--更多视频
      path: '/roadCondition/roadVideo',
      name: 'RoadVideo',
      component: resolve => require(['../container/roadCondition/roadVideo.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      // 路况--路况详情页面
      path: '/roadCondition/roadDetail',
      name: 'RoadDetail',
      component: resolve => require(['../container/roadCondition/roadDetail.vue'], resolve),
    },
    {
      // 路况--路况新闻详情页面
      path: '/roadCondition/roadNewDetail',
      name: 'RoadNewDetail',
      component: resolve => require(['../container/roadCondition/roadNewDetail.vue'], resolve),
    },
    {
      // 路况--路况视频详情页面
      path: '/roadCondition/roadVideoDetail',
      name: 'RoadVideoDetail',
      component: resolve => require(['../container/roadCondition/roadVideoDetail.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //登录
      path: '/login',
      name: 'Login',
      component: resolve => require(['../container/login/Index.vue'], resolve),
    },
    {
      //服务区地图页面
      path: '/serviceAreaMap',
      name: 'ServiceAreaMap',
      component: resolve => require(['../container/serviceArea/Map.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区上报
      path: '/serviceAreaReport',
      name: 'ServiceAreaReport',
      component: resolve => require(['../container/serviceArea/ReportInfo.vue'], resolve),
    },
    {
      //服务区地图搜索页面
      path: '/serviceAreaSearch',
      name: 'ServiceAreaSearch',
      component: resolve => require(['../container/serviceArea/ServiceSearch.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区异常页面
      path: '/abnormalArea',
      name: 'AbnormalArea',
      component: resolve => require(['../container/serviceArea/AbnormalArea.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区异常页面
      path: '/abnormalAreaMap',
      name: 'AbnormalAreaMap',
      component: resolve => require(['../container/serviceArea/AbnormalAreaMap.vue'], resolve),
      // meta:{keepAlive:true}
    },
    {
      //全部服务区页面
      path: '/ServiceAll',
      name: 'ServiceAll',
      component: resolve => require(['../container/serviceArea/ServiceAll.vue'], resolve),
      // meta:{keepAlive:true}
    },
    {
      //路况-视频播放页面
      path: '/roadCondition/videoPlay',
      name: 'VideoPlay',
      component: resolve => require(['../container/roadCondition/videoPlay.vue'], resolve),
    },
    {
      //路况-搜索页面
      path: '/roadCondition/roadSearch',
      name: 'RoadSearch',
      component: resolve => require(['../container/roadCondition/roadSearch.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //首页
      path: '/home',
      name: 'Home',
      component: resolve => require(['../container/home/Index.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //首页-新闻列表
      path: '/home/news',
      name: 'News',
      component: resolve => require(['../container/home/news.vue'], resolve),
    },
    {
      //首页-新闻详情
      path: '/home/newsDetail',
      name: 'NewsDetail',
      component: resolve => require(['../container/home/newsDetail.vue'], resolve),
    },
    {
      //首页-路况通知列表
      path: '/home/roadList',
      name: 'RoadList',
      component: resolve => require(['../container/home/roadList.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //首页-专题
      path: '/home/subject',
      name: 'Subject',
      component: resolve => require(['../container/home/subject.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //路线规划-首页
      path: '/travel',
      name: 'Travel',
      component: resolve => require(['../container/travel/Index.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //路线规划-地点查询
      path: '/locationQuery',
      name: 'LocationQuery',
      component: resolve => require(['../container/travel/LocationQuery.vue'], resolve),
    },
    {
      //单个服务区地图显示
      path: '/SingleAreaMap',
      name: 'SingleAreaMap',
      component: resolve => require(['../container/tsRoadCondition/serviceArea/SingleAreaMap'], resolve),
      meta:{keepAlive:true}
    },
    {
      //单个收费站地图显示
      path: '/SingleStationMap',
      name: 'SingleStationMap',
      component: resolve => require(['../container/tsRoadCondition/tollStation/SingleStationMap'], resolve),
      meta:{keepAlive:true}
    },
    {
      //app下载页面
      path: '/appDownload',
      name: 'AppDownload',
      component: resolve => require(['../container/AppDownload/index'], resolve),
    },
    {
      //路况播报页面
      path: '/roadBroadcast',
      name: 'RoadBroadcast',
      component: resolve => require(['../container/roadBroadcast/roadBroadcast'], resolve),
    },
    {
      //路况播报页面-详情界面
      path: '/rbDetail',
      name: 'RBDetail',
      component: resolve => require(['../container/roadBroadcast/roadDetail'], resolve),
    },
    {
      //路况播报页面-详情界面
      path: '/rbVideoDetail',
      name: 'RBVideoDetail',
      component: resolve => require(['../container/roadBroadcast/roadVideoDetail'], resolve),
    },
    {
      //路况播报页面
      path: '/rbNewDetail',
      name: 'RBNewDetail',
      component: resolve => require(['../container/roadBroadcast/roadNewDetail'], resolve),
    },
    {
      //服务区（微信公众号）
      path: '/wxServiceArea',
      name: 'WXServiceArea',
      component: resolve => require(['../container/wxServiceArea/Index'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区搜索（微信公众号）
      path: '/wxAreaSearch',
      name: 'WXAreaSearch',
      component: resolve => require(['../container/wxServiceArea/AreaSearch'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区地图（微信公众号）
      path: '/wxAreaMap',
      name: 'WXAreaMap',
      component: resolve => require(['../container/wxServiceArea/AreaMap'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区详情（微信公众号）
      path: '/wxAreaDetail',
      name: 'WXAreaDetail',
      component: resolve => require(['../container/wxServiceArea/AreaDetail'], resolve),
    },
    {
      //异常服务区（微信公众号）
      path: '/wxAbnormalArea',
      name: 'WXAbnormalArea',
      component: resolve => require(['../container/wxServiceArea/AbnormalArea'], resolve),
    },
    {
      //施工上报主页（微信公众号）
      path:'/roadReport',
      name:'RoadReport',
      component: resolve => require(['../container/roadReport/index'], resolve),
      meta:{keepAlive:true}
    },
    {
      //施工上报列表页（微信公众号）
      path:'/roadReportList',
      name:'RoadReportList',
      component: resolve => require(['../container/roadReport/list'], resolve),
      meta:{keepAlive:true}
    },
    {
      //施工上报详情页（微信公众号）
      path:'/roadReportInfo',
      name:'RoadReportInfo',
      component: resolve => require(['../container/roadReport/info'], resolve),
    },
    {
      //指定-专题
      path: '/home/appointSubject',
      name: 'appointSubject',
      component: resolve => require(['../container/home/appointSubject.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //出行服务，路况信息
      path: '/travel/roadInfo',
      name: 'travelRoadInfo',
      component: resolve => require(['../container/travel/roadInfo/Index.vue'], resolve),
      meta:{keepAlive:true}
    },
    {
      //服务区
      path: '/wxTollStation',
      name: 'WxTollStation',
      component: resolve => require(['../container/wxTollStation/Index'], resolve),
      meta:{keepAlive:true}
    },
    {
      // 路况概览详情
      path: '/wxTollStationSvg',
      name: 'WxTollStationSvg',
      component: resolve => require(['../container/wxTollStation/SvgDetail.vue'], resolve),
      // meta: {keepAlive: true}
    },
    {
      //收费站查询
      path: '/wxTollStationSearch',
      name: 'WxTollStationSearch',
      component: resolve => require(['../container/tollStation/StationSearch'], resolve),
      meta:{keepAlive:true}
    },
    {
      //收费站地图
      path: '/wxStationMap',
      name: 'WxStationMap',
      component: resolve => require(['../container/tollStation/StationMap'], resolve),
      meta:{keepAlive:true}
    },
    {
      //收费站详情
      path: '/wxStationDetail',
      name: 'WxStationDetail',
      component: resolve => require(['../container/tollStation/StationDetail'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js